import { render, staticRenderFns } from "./ArticleFavouriteView.vue?vue&type=template&id=061238d4&scoped=true"
import script from "./ArticleFavouriteView.vue?vue&type=script&lang=js"
export * from "./ArticleFavouriteView.vue?vue&type=script&lang=js"
import style0 from "./ArticleFavouriteView.vue?vue&type=style&index=0&id=061238d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061238d4",
  null
  
)

export default component.exports